import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TeregistrasiComponent } from './distributor-list/teregistrasi/teregistrasi.component';
import { PendingComponent } from './distributor-list/pending/pending.component';
import { RejectComponent } from './distributor-list/reject/reject.component';
import { HistoryComponent } from './distributor-detail/components/product-exclusive/history/history.component';
import { DocumentKULComponent } from './distributor-detail/detail-teregistrasi/components/document-kul/document-kul.component';

const routes: Routes = [
  // DISTRIBUTOR
  {
    path: '',
    redirectTo: 'teregistrasi/active',
    pathMatch: 'full',
  },

  {
    path: 'pending/:tab',
    component: PendingComponent,
    data: {
      enum: 'LIST_MENUNGGU',
    },
  },

  {
    path: 'reject/:tab',
    component: RejectComponent,
    data: {
      enum: 'LIST_DITOLAK',
    },
  },

  {
    path: 'teregistrasi/:tab',
    component: TeregistrasiComponent,
    data: {
      enum: 'LIST_TEREGISTRASI',
    },
  },

  // Distributor Detail
  {
    path: 'detail',
    loadChildren: () => import('./distributor-detail/distributor-detail.module').then((m) => m.DistributorDetailModule),
  },

  {
    path: 'kul/:id',
    component: DocumentKULComponent,
  },

  {
    path: 'product-exclusive/:id',
    component: HistoryComponent,
  },

  {
    path: 'product-exclusive-settings',
    loadChildren: () => import('./product-exclusive-settings/product-exclusive-settings.module').then((m) => m.ProductExclusiveSettingsModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DistributorRoutingModule {}
